/* eslint-disable no-param-reassign */
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ModalProps } from "types/modal";

export interface ModalState {
  isOpen: boolean;
  props: ModalProps | null;
}

const initialState: ModalState = {
  isOpen: false,
  props: null,
};

const slice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<ModalProps>) => {
      state.isOpen = true;
      state.props = {
        ...action.payload,
      };
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.props = null;
    },
  },
});

export const { openModal, closeModal } = slice.actions;

export default slice.reducer;
